import { API } from '../../utils/amplifyWrapper';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { assertFeatureCreditsOk } from '../organisation/featureCreditsGuard';

interface ICreateVoiceMixParams {
    org_id: string;
    integration_id: string;
    voice_name: string;
    language_code: string;
    voice_a_source: string;
    voice_b_source: string;
    voice_a_weight: number;
    voice_b_weight: number;
    voice_a_is_library?: boolean;
    voice_b_is_library?: boolean;
}

// Design/mix records live in the same cloned_voice table as clones (shared PK/SK), so
// list/poll continue to use useClonedVoices/fetchClonedVoiceById from useClonedVoice.ts —
// only creation needs a dedicated endpoint/payload shape.
export const useCreateVoiceMix = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async ({
            org_id,
            integration_id,
            voice_name,
            language_code,
            voice_a_source,
            voice_b_source,
            voice_a_weight,
            voice_b_weight,
            voice_a_is_library,
            voice_b_is_library,
        }: ICreateVoiceMixParams) => {
            const response = await API.post(
                'main',
                `/organisation/${org_id}/integration/${integration_id}/voice_mix`,
                {
                    body: {
                        voice_name,
                        language_code,
                        voice_a_source,
                        voice_b_source,
                        voice_a_weight,
                        voice_b_weight,
                        voice_a_is_library,
                        voice_b_is_library,
                    },
                    headers: { 'Content-Type': 'application/json' }
                }
            );
            assertFeatureCreditsOk(response);
            return { voiceId: response.data.id as string, org_id, integration_id };
        },
        {
            onSuccess: ({ org_id, integration_id }) => {
                queryClient.invalidateQueries(['cloned_voices', org_id, integration_id]);
            }
        }
    );
};
